<form class="card" [formGroup]="form" id="step1">
    <div class="card-body row">
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>No. Identificación</mat-label>
            <input type="text" formControlName="n_ide" matInput>
        </mat-form-field>

        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Cuenta</mat-label>
            <input type="number" formControlName="cue" matInput>
        </mat-form-field>

    </div>

    <div class="card-footer gap-1">
        <button mat-button type="button" (click)="buscar()" class="primary">
            Buscar
        </button>
    </div>
</form>

<coky-table class="mb-2 mt-2" [data]="listaCliente" title="Resultado" [columns]="defaultColumns"
    [multipleSelection]="false" (clickRow)="clienteSeleccionado($event)" *ngIf="STEP > 1" id="step2">
</coky-table>

<div class="card mb-2" *ngIf="STEP > 2" id="step3">
    <div class="card-header pb-3 pt-3">
        Generar reporte para la factura: <strong>{{listaClienteSeleccionados[0].factura}}</strong>
    </div>

    <div class="card-body row">

        <div class="col-md-12" [formGroup]="formTipo">
            <mat-form-field appearance="fill" class="col-12 col-md-12">
                <mat-label>Tipo de Historial</mat-label>
                <mat-select formControlName="tipo">
                    <mat-option value="hist-pagos-det">HISTORICO DE PAGOS DETALLADO</mat-option>
                    <mat-option value="det-cuotas">DETALLE DE CUOTAS</mat-option>
                    <mat-option *ngIf="esConexionJP" value="est-cuenta">ESTADO DE CUENTA</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </div>
    <div class="card-footer pb-2 pt-2">
        <button mat-button type="button" (click)="descargar()" class="secondary">
            Descargar
        </button>
    </div>
</div>
